import { createAction } from 'redux-actions';

import { CART_UPDATED, LOAD_CART_DATA } from '../constants/actionTypes';

const updateCartAction = createAction(CART_UPDATED);

export function updateCart(payload) {
    return dispatch => dispatch(updateCartAction(payload));
}

const loadCartDataAction = createAction(LOAD_CART_DATA);

export function loadCartData(payload) {
    return dispatch => dispatch(loadCartDataAction(payload));
}